import { api } from './api';

const deliverableShow = (appid) => {
  return api({method: 'GET', url: process.env.REACT_APP_API_URL+'/deliverable/'+appid+'/show'});
}

const deliverableSave = (input, appid, no_popup_msg = false) => {
  return api({method: 'POST', url: process.env.REACT_APP_API_URL+'/deliverable/'+appid+'/save', no_popup_msg: no_popup_msg}, input);
}

const deliverableDelete = (id, field) => {
  return api({method: 'DELETE', url: process.env.REACT_APP_API_URL+'/deliverable/'+id+'/delete?field='+field});
}


export const deliverableService = {
  deliverableShow,
  deliverableSave,
  deliverableDelete
};